import React, { useMemo, useState } from "react";
import { CommonAttachmentDetails } from "./Attachments/CommonAttachmentDetails";
import { CommonAttachmentTable } from "./Attachments/CommonAttachmentTable";

export const CommonAttachmentsTab = (props) => {
    const { 
        licenceApplication, 
        applicationType, 
        applicationMode,
        documentTypes,
        isArchiveApplication
    } = props;

    const documentsToShow = useMemo(() => {
        const docs = []
        licenceApplication.documents.forEach((document) => {
            if(documentTypes.find(t => t === document.documentType)) {
                docs.push(document)
            } 
        })
        return docs
    }, [licenceApplication.documents, documentTypes])

    const [attachment, setAttachment] = useState()

    return attachment 
    ? <CommonAttachmentDetails 
        attachment={attachment} 
        licenceApplication={licenceApplication} 
        setAttachment={setAttachment} 
        applicationType={applicationType}
        applicationMode={applicationMode} 
        isArchiveApplication={isArchiveApplication}
    />
    : <CommonAttachmentTable 
        documentTypes={documentTypes}
        attachments={documentsToShow ?? []} 
        licenceApplication={licenceApplication} 
        applicationType={applicationType} 
        applicationMode={applicationMode} 
        setAttachment={setAttachment} 
        peopleList={props.peopleList}
        onFileUpload={props.onFileUpload}
        showEntityDetails={props.showEntityDetails}
        isArchiveApplication={isArchiveApplication}
      />
}
